const HotdeskingConfig = {
  baseURI: "/hotdesking",
  dateFormat: "YYYY-MM-DD",
  status: {
    AVAILABLE: "AVAILABLE",
    INUSE: "IN_USE",
    NOTUSE: "NOT_USE",
  },
  menuType: {
    today: "today",
    user: "user",
  },
};

export default HotdeskingConfig;

// export declare const FloatingPanel: React.ForwardRefExoticComponent<{
//     anchors: number[];
//     children: ReactNode;
//     onHeightChange?: ((height: number, animating: boolean) => void) | undefined;
//     handleDraggingOfContent?: boolean | undefined;
//     placement?: "bottom" | "top" | undefined;
// }
